import React, { useState } from "react";
import { connect } from "react-redux";
import {
  Box,
  List,
  ListItem,
  ListItemText,
  Button,
  Typography,
  IconButton,
} from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Cancel";
import RespondInvitation from "./RespondInvitation";
import RespondRequest from "./RespondRequest";

const NotificationsList = ({ closeModal, mindfile }) => {
  const [selectedInvite, setSelectedInvite] = useState(false);
  const [selectedRequest, setSelectedRequest] = useState(false);

  const invitations = mindfile.invitations_received.map(invitation => {
    return (
      <ListItem
        key={invitation.id}
        button
        onClick={() =>
          setSelectedInvite({
            name: invitation.name,
            id: invitation.id,
          })
        }
      >
        <ListItemText>{invitation.name}</ListItemText>
        <Button variant="contained" color="primary">
          Respond
        </Button>
      </ListItem>
    );
  });

  const requests = mindfile.requests.map(request => {
    return (
      <ListItem
        key={request.id}
        button
        onClick={() =>
          setSelectedRequest({
            name: request.name,
            id: request.id,
          })
        }
      >
        <ListItemText>{request.name}</ListItemText>
        <Button variant="contained" color="primary">
          Respond
        </Button>
      </ListItem>
    );
  });

  const invitationsList = (
    <>
      <Box>
        <Typography variant="h6">Invitations</Typography>
      </Box>
      <List>{invitations}</List>
    </>
  );

  const requestsList = (
    <>
      <Box>
        <Typography variant="h6">Requests</Typography>
      </Box>
      <List>{requests}</List>
    </>
  );

  return (
    <Box
      style={{
        backgroundColor: "white",
        maxWidth: 600,
        width: "100%",
        padding: "16px 32px",
        maxHeight: "80dvh",
        overflow: "scroll",
      }}
    >
      <Box style={{ display: "inline-block", float: "right" }}>
        <IconButton onClick={closeModal}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Box>
      <Box pt={5} />
      {!selectedInvite && !selectedRequest ? (
        <>
          {invitationsList}
          <Box mt={2} />
          {requestsList}
        </>
      ) : null}
      {selectedInvite && !selectedRequest ? (
        <RespondInvitation
          name={selectedInvite.name}
          invitationId={selectedInvite.id}
          close={closeModal}
        />
      ) : null}
      {selectedRequest && !selectedInvite ? (
        <RespondRequest
          name={selectedRequest.name}
          requestId={selectedRequest.id}
          close={closeModal}
        />
      ) : null}
    </Box>
  );
};

const mapStateToProps = state => ({
  mindfile: state.mindfile,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsList);
